// extracted by mini-css-extract-plugin
export var container = "bB_c";
export var description = "bB_p";
export var formContainer = "bB_6";
export var neutral100 = "bB_dY";
export var neutral80 = "bB_dX";
export var textContainer = "bB_dk";
export var title = "bB_h";